import React from 'react';
import { useSelector } from 'react-redux';

import { selectDarkMode } from '../../../../../../../../../../userBrowserSettings/store/browserSettings.selectors';

import SkeletonLoading from '../../../../../../../../../common/SkeletonLoading';
import CustomTypography from '../../../../../../../../../common/styledTypography/CustomTypography';

import {
    selectIsRanksHtagsLoaded,
    selectRanksHtags,
} from '../../store/contentBriefsOutline.selectors';

import { getThemeColorClass } from '../../../../../../../../../../utils/helpers/themeHelpers';

import RankItem from './rankItem/RankItem';

import './Ranks.scss';

const classes = {
    ranksContainer: 'ranks-container',
    ranksInfoWrapper: 'ranks-info-wrapper',
};

const RanksContainer = () => {
    const darkMode = useSelector(selectDarkMode);
    const themeColorClass = getThemeColorClass(darkMode);

    const ranksHtags = useSelector(selectRanksHtags);
    const isRanksHtagsLoaded = useSelector(selectIsRanksHtagsLoaded);

    return (
        <div className={`${classes.ranksContainer} ${themeColorClass}`}>
            {isRanksHtagsLoaded ? (
                ranksHtags?.length > 0 ? (
                    ranksHtags
                        ?.filter((x) =>
                            x.include_in_optimal_range !== undefined
                                ? x.include_in_optimal_range
                                : true
                        )
                        ?.map((rank, index) => {
                            return (
                                <RankItem rank={rank} index={index} key={`${index}-${rank?.url}`} />
                            );
                        })
                ) : (
                    <div className={classes.ranksInfoWrapper}>
                        <CustomTypography
                            text={
                                'No data. Try to change competitor positions analyzed in Optimizer settings.'
                            }
                        />
                    </div>
                )
            ) : (
                <SkeletonLoading width='96%' />
            )}
        </div>
    );
};

export default RanksContainer;
